import React, { useCallback } from 'react';
import { Button } from 'antd';

const SaveConfirmButton = ({ onConfirm, loading = false, children = 'Save', ...buttonProps }) => {
  const handleOpen = useCallback(async () => {
    if (loading) return;
    await onConfirm?.();
  }, [loading, onConfirm]);

  return (
    <>
      <Button {...buttonProps} onClick={handleOpen} loading={loading}>
        {children}
      </Button>
      {/* <Modal
        title="Confirm Save"
        open={open}
        onOk={handleConfirm}
        onCancel={handleCancel}
        confirmLoading={loading}
        okText="Confirm"
        cancelText="Cancel"
        maskClosable={false}
      >
        Are you sure you want to save the current changes?
      </Modal> */}
    </>
  );
};

export default SaveConfirmButton;
